import { render, staticRenderFns } from "./CreateMGateBottomSheet.vue?vue&type=template&id=4bbe2179&scoped=true"
import script from "./CreateMGateBottomSheet.vue?vue&type=script&lang=js"
export * from "./CreateMGateBottomSheet.vue?vue&type=script&lang=js"
import style0 from "./CreateMGateBottomSheet.vue?vue&type=style&index=0&id=4bbe2179&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbe2179",
  null
  
)

export default component.exports